import React from 'react';
import { Select } from 'antd';
import { useFamilles } from '../../hooks/familleHooks';
import { useFetchAllFours } from '../../hooks/fourHooks';

const option = (code, name) => ({ value: code, label: `${code} - ${name || 'Sans nom'}` });

function RelationSelect({ loading, error, ...props }) {
  return <Select
    showSearch
    allowClear
    optionFilterProp="label"
    listHeight={256}
    style={{ width: '100%' }}
    {...props}
    loading={loading}
    status={error ? 'error' : props.status}
    notFoundContent={error ? 'Impossible de charger la liste' : loading ? 'Chargement...' : 'Aucun résultat'}
  />;
}

export function FamilleSelect(props) {
  const { familles, loading, error } = useFamilles();
  return <RelationSelect {...props} placeholder="Sélectionner une famille" loading={loading} error={error}
    options={familles.map(famille => option(famille.code_fam, famille.nom))} />;
}

export function SousFamilleSelect({ familyCode, ...props }) {
  const { familles, loading, error } = useFamilles();
  const famille = familles.find(item => item.code_fam === familyCode);
  return <RelationSelect {...props} disabled={props.disabled || !familyCode}
    placeholder={familyCode ? 'Sélectionner une sous-famille' : 'Sélectionner d’abord une famille'}
    loading={loading} error={error}
    options={(famille?.sousFamilles || []).map(item => option(item.code_sfam, item.sfamille))} />;
}

export function FournisseurSelect(props) {
  const { Fours, loading, error } = useFetchAllFours();
  return <RelationSelect {...props} placeholder="Sélectionner un fournisseur" loading={loading} error={error}
    options={Fours.map(fournisseur => option(fournisseur.code_frs, fournisseur.sociale))} />;
}
